import { createApp } from 'vue'
import router from '@/router.js'
import App from '@/App.vue'
import networking from '@/networking.js'
import store from '@/state.js'
import '@/styles/custom.scss'

createApp(App).use(store).use(router).mount('#app')

networking.init()

// init announcement lastread
const lastRead = window.localStorage.getItem('announcementReadTime')
if (lastRead === null) {
    window.localStorage.setItem('announcementReadTime', Date.now())
    store.commit('readAnnouncements')
} else {
    store.commit('setAnnouncementReadTime', lastRead)
}

// The Konami code shakes the page through a glitch storm, as on the wargame platform.
const konami = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a']
const recentKeys = []
window.addEventListener('keydown', (event) => {
    recentKeys.push(event.key.length === 1 ? event.key.toLowerCase() : event.key)
    if (recentKeys.length > konami.length) recentKeys.shift()
    if (recentKeys.join() !== konami.join()) return
    recentKeys.length = 0

    const root = document.documentElement
    root.classList.remove('ssm-glitch-storm')
    root.getBoundingClientRect() // restart the animation if it is already running
    root.classList.add('ssm-glitch-storm')
    setTimeout(() => root.classList.remove('ssm-glitch-storm'), 2000)
})
